import { styled } from './stitches.config';

export const Section = styled('div', {});

export const Header = styled('header', {
	padding: '0 $x2 $x2',
	textAlign: 'center',
});
